'use client';

import { ButtonProps } from '@mui/material';
import { EmptyState } from '@/components/ui/EmptyState/EmptyState';
export const DataGridEmptyOverlay = ({
  hasActiveFilter,
  resourceLabel,
  emptyDescription,
  onClearFilters,
  createAction,
  // DataGrid injects overlay layout props; keep them off EmptyState.
  className: _className,
  style: _style,
  sx: _sx,
  ..._rest
}) => {
  return <div className="flex h-full w-full items-center justify-center">
            <EmptyState illustration={hasActiveFilter ? {
      src: '/images/illustrations/zoom-front-clay.png',
      alt: 'Search'
    } : {
      src: '/images/illustrations/folder-front-clay.png',
      alt: 'Folder'
    }} title={hasActiveFilter ? 'No results found' : `No ${resourceLabel} found`} description={hasActiveFilter ? 'No data found. Please try a different search or filter.' : emptyDescription} secondaryButton={hasActiveFilter ? {
      children: 'Clear filters',
      onClick: onClearFilters
    } : createAction} />
        </div>;
};